import type { EventParticipantIdPublic } from "../schemas/branded-id.schemas.js";
import type { Paginated } from "../schemas/paginated.schemas.js";
import type { DemoPersonaSeedSummary } from "../schemas/demo-persona-seed-summary.schemas.js";

export const ParticipantDataIssueType = {
  DUPLICATE_EMAIL: "DUPLICATE_EMAIL",
  DUPLICATE_PHONE: "DUPLICATE_PHONE",
  DUPLICATE_LINKEDIN_URL: "DUPLICATE_LINKEDIN_URL",
  INVALID_FIELDS: "INVALID_FIELDS",
} as const;

export type ParticipantDataIssueValueType =
  (typeof ParticipantDataIssueType)[keyof typeof ParticipantDataIssueType];

export interface ParticipantListDataIssue {
  readonly type: ParticipantDataIssueValueType;
  readonly value: string;
  readonly participantIdPublics: readonly EventParticipantIdPublic[];
}

export interface PaginatedParticipantList<T> extends Paginated<T> {
  readonly dataIssues: readonly ParticipantListDataIssue[];
  // Present only on demo events; mirrored in paginatedParticipantListResponseSchema
  // so it survives the frontend zod parse (`| undefined` matches zod `.optional()`).
  readonly demoPersonaSummary?: DemoPersonaSeedSummary | undefined;
}
